export default "__VITE_ASSET__s$FIAVbs__"